module.exports = __webpack_public_path__ + "static/img/mine_privacy@3x.85b7c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_privacy@3x.png
// module id = GhJQ
// module chunks = 1